/**
 * On-brand aerial roof plan diagram (SVG) — a representative "report" visual.
 * Navy facets with Chalk-Orange ridge/hip/valley lines + dimension labels.
 */
export default function RoofDiagram({ className = "", showLabels = true }) {
  return (
    <svg viewBox="0 0 400 240" className={className} role="img" aria-label="Aerial roof measurement diagram" preserveAspectRatio="xMidYMid meet">
      <rect x="0" y="0" width="400" height="240" rx="8" fill="#1E2A35" />
      {/* subtle grid */}
      <g opacity="0.12" stroke="#ffffff" strokeWidth="1">
        {Array.from({ length: 9 }).map((_, i) => <line key={`v${i}`} x1={(i + 1) * 40} y1="0" x2={(i + 1) * 40} y2="240" />)}
        {Array.from({ length: 5 }).map((_, i) => <line key={`h${i}`} x1="0" y1={(i + 1) * 40} x2="400" y2={(i + 1) * 40} />)}
      </g>

      {/* Roof facets (hip + gable composite) */}
      <g stroke="#0f1620" strokeWidth="1.5">
        {/* main hip block */}
        <polygon points="60,60 200,60 170,120 90,120" fill="#33475a" />
        <polygon points="60,60 90,120 60,180 30,120" fill="#2a3b4c" />
        <polygon points="200,60 170,120 200,180 230,120" fill="#2a3b4c" />
        <polygon points="60,180 90,120 170,120 200,180" fill="#3c5267" />
        {/* attached gable wing */}
        <polygon points="230,90 340,90 360,140 250,140" fill="#33475a" />
        <polygon points="230,90 250,140 230,190 210,140" fill="#2a3b4c" />
        <polygon points="340,90 360,140 340,190 320,140" fill="#2a3b4c" />
        <polygon points="230,190 250,140 340,140 360,190" fill="#3c5267" />
      </g>

      {/* Ridge / hip / valley lines (orange = key measured edges) */}
      <g stroke="#E07B2A" strokeWidth="2.5" fill="none" strokeLinecap="round">
        <line x1="90" y1="120" x2="170" y2="120" />   {/* ridge */}
        <line x1="250" y1="140" x2="340" y2="140" />   {/* ridge */}
      </g>
      <g stroke="#E07B2A" strokeWidth="1.6" fill="none" opacity="0.85">
        <line x1="60" y1="60" x2="90" y2="120" />
        <line x1="200" y1="60" x2="170" y2="120" />
        <line x1="60" y1="180" x2="90" y2="120" />
        <line x1="200" y1="180" x2="170" y2="120" />
        <line x1="230" y1="90" x2="250" y2="140" />
        <line x1="340" y1="90" x2="360" y2="140" />
      </g>
      {/* valley where wings meet */}
      <line x1="200" y1="120" x2="230" y2="140" stroke="#2E7D32" strokeWidth="2.2" />

      {showLabels && (
        <g fontFamily="'Source Sans 3', sans-serif" fontWeight="700">
          <g>
            <rect x="96" y="106" width="68" height="18" rx="9" fill="#E07B2A" />
            <text x="130" y="119" textAnchor="middle" fontSize="10" fill="#fff">Ridge 78'</text>
          </g>
          <g>
            <rect x="20" y="112" width="40" height="16" rx="8" fill="#0f1620" />
            <text x="40" y="124" textAnchor="middle" fontSize="9" fill="#E07B2A">6/12</text>
          </g>
          <g>
            <rect x="196" y="150" width="56" height="16" rx="8" fill="#2E7D32" />
            <text x="224" y="162" textAnchor="middle" fontSize="9" fill="#fff">Valley 32'</text>
          </g>
        </g>
      )}
    </svg>
  );
}
